import { render, staticRenderFns } from "./g-avatar.vue?vue&type=template&id=b31dece4&scoped=true"
import script from "./g-avatar.vue?vue&type=script&lang=js"
export * from "./g-avatar.vue?vue&type=script&lang=js"
import style0 from "./g-avatar.vue?vue&type=style&index=0&id=b31dece4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31dece4",
  null
  
)

export default component.exports